module.exports = __webpack_public_path__ + "img/storagedevices.fce3b85b.jpeg";